import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

import { Config, IConfig } from '../config/config.model';
import { CnPlaylist, UserPlaylist } from '../models';

import { Auth } from '../../root-store';

@Injectable({
    providedIn: 'root'
})
export class PlaylistService {
    private apiUrl: string;

    constructor(
        private http: HttpClient,
        private store: Store<Auth.State>,
        @Inject(Config) config: IConfig
    ) {
        this.apiUrl = config.apiUrl;
    }

    public createUserPlaylist(playlist: UserPlaylist, courses?: number[]): Observable<UserPlaylist> {
        return this.store.select(Auth.selectSchoolId).pipe(
            take(1),
            switchMap((schoolId: number) => this.http.post<UserPlaylist>(`${this.apiUrl}/schools/${schoolId}/playlists/my-playlists`, { playlist, courses }))
        );
    }

    public deleteUserPlaylist(playlistId: number): Observable<void> {
        return this.store.select(Auth.selectSchoolId).pipe(
            take(1),
            switchMap((schoolId: number) => this.http.delete<void>(`${this.apiUrl}/schools/${schoolId}/playlists/my-playlists/${playlistId}`))
        );
    }

    public getAll(subjects?: number[]): Observable<CnPlaylist[]> {
        const params: any = {};
        if (subjects) {
            params.subjects = subjects;
        }

        return this.store.select(Auth.selectSchoolId).pipe(
            take(1),
            switchMap((schoolId: number) => this.http.get<CnPlaylist[]>(`${this.apiUrl}/schools/${schoolId}/playlists`, { params }))
        );
    }

    public getAllUserPlaylists(): Observable<UserPlaylist[]> {
        return this.store.select(Auth.selectSchoolId).pipe(
            take(1),
            switchMap((schoolId: number) => this.http.get<UserPlaylist[]>(`${this.apiUrl}/schools/${schoolId}/playlists/my-playlists`))
        );
    }

    public editUserPlaylist(playlist: UserPlaylist, courses?: number[]): Observable<void> {
        return this.store.select(Auth.selectSchoolId).pipe(
            take(1),
            switchMap((schoolId: number) => this.http.put<undefined>(`${this.apiUrl}/schools/${schoolId}/playlists/my-playlists/${playlist.id}`, { playlist, courses }))
        );
    }

    public logCnPlaylistUsage(playlistId: number, courseId: number): Observable<void> {
        return this.store.select(Auth.selectSchoolId).pipe(
            take(1),
            switchMap((schoolId: number) => this.http.put<undefined>(`${this.apiUrl}/schools/${schoolId}/playlists/${playlistId}/usage`, { course: courseId }))
        );
    }

    public logUserPlaylistUsage(playlistId: number, courseId: number): Observable<void> {
        return this.store.select(Auth.selectSchoolId).pipe(
            take(1),
            switchMap((schoolId: number) => this.http.put<undefined>(`${this.apiUrl}/schools/${schoolId}/playlists/my-playlists/${playlistId}/usage`, { course: courseId }))
        );
    }
}